var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mostrar
    ? _c(
        "div",
        { staticClass: "chat-message-fontes-web mb-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "chat-message-fontes-web__titulo az-text-secondary az-size-12 mb-2"
            },
            [_vm._v(" Fontes da internet consultadas nesta resposta ")]
          ),
          _vm._l(_vm.fontesExibidas, function(fonte) {
            return _c(
              "a",
              {
                key: fonte.url,
                staticClass:
                  "chat-message-fontes-web__cartao d-flex align-center az-gap-small px-3 py-2 mb-2",
                attrs: {
                  href: fonte.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "data-test": "fonte-web-cartao"
                }
              },
              [
                _c("icon-svg", {
                  staticClass: "chat-message-fontes-web__icone flex-shrink-0",
                  attrs: {
                    name: "open-external",
                    size: 14,
                    color: "var(--neutral-600)"
                  }
                }),
                _c(
                  "span",
                  {
                    staticClass:
                      "chat-message-fontes-web__texto d-flex flex-column"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "chat-message-fontes-web__nome az-text-primary az-size-14 font-weight-medium",
                        attrs: { "data-test": "fonte-web-titulo" }
                      },
                      [_vm._v(_vm._s(fonte.titulo))]
                    ),
                    _c(
                      "span",
                      { staticClass: "az-text-secondary az-size-12 az-muted" },
                      [
                        _c(
                          "span",
                          { attrs: { "data-test": "fonte-web-dominio" } },
                          [_vm._v(_vm._s(fonte.dominio))]
                        ),
                        fonte.coletadoEm
                          ? _c(
                              "span",
                              { attrs: { "data-test": "fonte-web-data" } },
                              [
                                _vm._v(
                                  " · coletada em " + _vm._s(fonte.coletadoEm)
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ],
              1
            )
          }),
          _vm.mostrarVerMais
            ? _c(
                "button",
                {
                  staticClass:
                    "chat-message-fontes-web__ver-mais az-text-secondary az-size-12 text-left",
                  attrs: { "data-test": "fonte-web-ver-mais" },
                  on: { click: _vm.expandir }
                },
                [_vm._v(" Ver mais " + _vm._s(_vm.restantes) + " fontes ")]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }